<template>
  <b-form-group
    label="Banka Hesabı"
    label-for="id_bank_accounts"
  >
    <v-select
      id="id_bank_accounts"
      v-model="filterParams.id_bank_accounts"
      :options="bankAccounts"
      label="title"
      :reduce="item => item.id"
      placeholder="Tümü"
      :disabled="filterParams.id_safes.length > 0"
      multiple
      @input="checkSelect"
    />
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'BankAccounts',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    bankAccounts() {
      return this.$store.getters['bankAccounts/dataList']
    },
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
  created() {
    this.getBankAccounts()
  },
  methods: {
    checkSelect() {
      if (this.filterParams.id_safes.length > 0) {
        this.filterParams.id_safes = []
      }
    },
    getBankAccounts() {
      this.$store.dispatch('bankAccounts/getDataList')
    },
  },
}
</script>
